module.exports = __webpack_public_path__ + "img/资源 27.75cd6e8b.png";